import React from "react";
import ListView from "../../../../shared/components/ListView";
import { HistoryTableColumns } from "../../../../configs/products";
import HistoryTableRows from "./HistoryTableRows";

interface TransactionProps {
  materialId: string;
}

const TransactionHistory = ({ materialId }: TransactionProps) => {
  return (
    <ListView
      url={`/materials/${materialId}/transactions/`}
      rowElement={HistoryTableRows}
      tableColumns={HistoryTableColumns}
    />
  );
};

export default TransactionHistory;
